import { ErrorHandler, inject, Injectable } from '@angular/core';
import { ErrorOrError, ErrorType } from '../../results';
import { ToastService } from '../../../../trash/shared/components';
import { Logger } from '../logging';

@Injectable()
export class CoreErrorHandler implements ErrorHandler {
  toastService: ToastService = inject(ToastService);

  handleError(error: unknown): void {
    if (Array.isArray(error) && error.every((e) => e instanceof ErrorOrError)) {
      this.handleErrorOrErrors(error);
      return;
    }

    Logger.error('Unknown Error has been occured', error);

    if (error instanceof Error) {
      // this.toastService.showError('An Error has occured', error.message);
      return;
    }
  }

  private handleErrorOrErrors(
    errors: ErrorOrError[],
    customErrors: ErrorOrError[] = [],
    validationErrorsHandler: ((errors: ErrorOrError[]) => void) | undefined = undefined
  ): any {
    let firstError = errors[0];

    if (validationErrorsHandler && firstError.type == ErrorType.VALIDATION) {
      validationErrorsHandler(errors);
      return;
    }

    let error = customErrors.find((x) => x.type == firstError.type);

    if (error) {
      this.showError(error, this.toastService);
      return;
    }
    this.toastService.showError(firstError?.code, firstError?.toErrorMessage());
  }

  private showError(error: ErrorOrError, toastService: ToastService) {
    toastService.showError(error.code, error.description);
  }
}
